import React from "react";
import { Ticket } from "lucide-react";

import { juntarNomes } from "./beneficios";

// Checkout: deixa claro, antes de o cliente tentar, em quais produtos o cupom não vale.
export default function AvisoCupom({ nomes, baseCupom, darkMode }) {
  if (!nomes || nomes.length === 0) return null;
  const valor = `R$ ${Number(baseCupom || 0).toFixed(2).replace(".", ",")}`;
  return (
    <div
      className={`flex items-start gap-2 p-2.5 rounded-xl border text-[11px] leading-snug ${darkMode ? "border-amber-500/30 bg-amber-500/10 text-amber-200" : "border-amber-300 bg-amber-50 text-amber-900"}`}
      data-e2e="aviso-cupom"
    >
      <Ticket className="w-4 h-4 shrink-0 mt-px" />
      <p>
        {baseCupom > 0 ? (
          <>Cupom de desconto <b>não vale</b> para {juntarNomes(nomes)}. O desconto do cupom é calculado só sobre os outros produtos ({valor}).</>
        ) : (
          <>Os produtos do seu carrinho ({juntarNomes(nomes)}) <b>não aceitam cupom de desconto</b>.</>
        )}
      </p>
    </div>
  );
}
